import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
//----- store
import {
	fetchPageData,
	sendEnrollmentRequestData,
} from "../store/CatalogDetails-actions";
import { CatalogDetailsActions } from "../store/CatalogDetails-slice";

import HeaderBreadCrumb from "../components/HeaderBreadCrumb/HeaderBreadCrumb";
import CardImage from "../components/CardImage/CardImage";
import RatingStars from "../components/RatingStars/RatingStars";
import TitleAndText from "../components/TitleAndText/TitleAndText";
import TableDate from "../components/TableDate/TableDate";
import TableCourseDetails from "../components/TableCourseDetails/TableCourseDetails";
import TableCourseModules from "../components/TableCourseModules/TableCourseModules";
import Contacts from "../components/Contacts/Contacts";
import Modal from "../components/UI/Modal/Modal";
import ModalBtns from "../components/UI/ModalBtns/ModalBtns";
import ModalTextAndButton from "../components/UI/ModalTextAndButton/ModalTextAndButton";

import Styles from "./CatalogDetails.module.css";

const DashboardCatalogDetails = () => {
	const dispatch = useDispatch();
	const [catalogDetailsDataLoaded, setCatalogDetailsData] = useState(false);
	const [modalVisible, setModalVisible] = useState(false);
	const [modalType, setModalType] = useState(0);
	const [modalStatus, setModalStatus] = useState(0);
	const params = useParams();
	const history = useHistory();
	console.log("params.courseId", params.courseId);

	const queryString = new URLSearchParams(window.location.search);
	const urlParams = {};
	for (var param of queryString.entries()) {
		urlParams[param[0]] = param[1];
	}
	console.log("urlParams", urlParams);

	const CatalogDetailsData = useSelector((state) => state.CatalogDetailsData);
	const apiConfigData = useSelector((state) => state.apiConfigData);
	const autenticationData = useSelector(
		(state) => state.uiData.autentication
	);

	const url_data =
		apiConfigData.endpoint.domain +
		apiConfigData.endpoint.catalogDetails +
		"/" +
		params.courseId +
		"?TrainingType=" +
		urlParams.TrainingType;

	const onPedirInscricaoHandler = () => {
		console.log("pedir inscrição");
		setModalVisible(true);
	};

	const onModalConfirmationHandler = () => {
		console.log("ok");

		let requestData = {};
		let urlData = "";

		if (urlParams.TrainingType == "Enumerable.TrainingType.Program") {
			requestData = {
				programId: CatalogDetailsData.pageData.id,
				siteId: CatalogDetailsData.pageData.subSite.siteId,
				subSiteId: CatalogDetailsData.pageData.subSite.id,
			};

			urlData =
				apiConfigData.endpoint.domain +
				apiConfigData.endpoint.courseEnrollRequest;
		} else {
			requestData = {
				courseId: CatalogDetailsData.pageData.courseId,
				courseVersionId: CatalogDetailsData.pageData.id,
				siteId: CatalogDetailsData.pageData.subSite.siteId,
				subSiteId: CatalogDetailsData.pageData.subSite.id,
			};

			urlData =
				apiConfigData.endpoint.domain +
				apiConfigData.endpoint.moduleEnrollRequest;
		}

		setModalVisible(false);

		dispatch(
			sendEnrollmentRequestData(urlData, requestData, autenticationData)
		);
	};

	const onModalCancelHandler = () => {
		console.log("cancel");
		setModalVisible(false);
		if (CatalogDetailsData.modalData.visible) {
			dispatch(CatalogDetailsActions.resetModalData());
		}
	};

	useEffect(() => {
		// console.log("||||||||||||||||||| catalogDetailsDataLoaded", catalogDetailsDataLoaded)
		console.log("CatalogDetailsData", CatalogDetailsData);

		// visible: false,
		// type: 0, // 0 = Confirmação | 1 = Notificação
		// status: 0, // 0 = error | 1 = success
		setModalType(0);
		setModalStatus(0);
		setModalVisible(false);

		if (CatalogDetailsData.modalData.visible) {
			setModalType(1);
			setModalStatus(1);
			setModalVisible(true);
		}
	}, [CatalogDetailsData]);

	useEffect(() => {
		dispatch(fetchPageData(url_data, autenticationData));
		setCatalogDetailsData(true);
	}, [dispatch]);

	return (
		<div className={Styles["dashboardCatalogDetails"]}>
			{catalogDetailsDataLoaded && (
				<div className={`container ${Styles["container"]}`}>
					<div className={"row"}>
						<div className={"col-xs-12 title"}>
							<HeaderBreadCrumb />
						</div>
					</div>
					<div className={"row"}>
						<div className={"col-xs-6"}>
							<div className={Styles["course-details-title"]}>
								{CatalogDetailsData.pageData.catalogNode.nome}
							</div>
							<div className={Styles["rating"]}>
								<RatingStars
									rating={
										CatalogDetailsData.pageData.ratingEval
											? CatalogDetailsData.pageData
													.ratingEval
											: 0
									}
									readOnly
								/>
							</div>
							<div className={`title ${Styles["title"]}`}>
								{CatalogDetailsData.pageData.nome}
							</div>
							<TableCourseDetails
								category={
									CatalogDetailsData.pageData.catalogNode.nome
								}
								trainingHours={
									CatalogDetailsData.pageData.durationSpan
								}
								trainingCenter={
									CatalogDetailsData.pageData.subSite.name
								}
							/>
							<TitleAndText
								title="Descrição do curso"
								text={CatalogDetailsData.pageData.descricao}
							/>

							{/* <TitleAndText
							title="Perfil dos Formandos"
							text={CatalogDetailsData.pageData.descricao}
						/> */}

							{/* {urlParams.TrainingType == "Enumerable.TrainingType.Program" && <TableDate
							initialDateTitle="Data inicío"
							initialDateText="24 de Março 2021"
							finalDateTitle="Data fim"
							finalDateText="30 de Março 2021"
						/>} */}

							{urlParams.TrainingType ==
								"Enumerable.TrainingType.Program" && (
								<div
									className={Styles["course-details-title"]}
									style={{ paddingTop: "20px" }}
								>
									Módulos deste curso
								</div>
							)}
							{urlParams.TrainingType ==
								"Enumerable.TrainingType.Program" &&
								CatalogDetailsData.pageData.courseVersions && (
									<TableCourseModules
										modules={
											CatalogDetailsData.pageData
												.courseVersions
										}
									/>
								)}
						</div>
						<div className={"col-xs-6"}>
							<CardImage
								btnTitle="Pedir inscrição"
								img={CatalogDetailsData.pageData.base64Image}
								onClick={onPedirInscricaoHandler}
							/>
							<Contacts
								subSite={
									CatalogDetailsData.pageData.subSite.name
								}
								address={
									CatalogDetailsData.pageData.subSite.address
								}
								zipCode={
									CatalogDetailsData.pageData.subSite.zipCode
								}
								city={CatalogDetailsData.pageData.subSite.city}
								contactTitle={"Contactos"}
								phone={
									CatalogDetailsData.pageData.subSite
										.telephone
								}
								email={
									CatalogDetailsData.pageData.subSite.email
								}
							/>
						</div>
					</div>
				</div>
			)}
			{modalVisible && (
				<Modal>
					{modalType === 0 && (
						<ModalBtns
							title={"Pedido de inscrição"}
							text={
								"Tem a certeza de que pretende efectuar o pedido de inscrição?"
							}
							onOk={onModalConfirmationHandler}
							onCancel={onModalCancelHandler}
						/>
					)}
					{modalType === 1 && (
						<ModalTextAndButton
							status={modalStatus}
							title={"Sucesso"}
							text={"O seu pedido foi realizado com sucesso."}
							onCancel={onModalCancelHandler}
						/>
					)}
				</Modal>
			)}
		</div>
	);
};

export default DashboardCatalogDetails;
